export const COMPANY_NAME = 'NELSONVILLE YORK BAND BOOSTERS';
export const COMPANY_SHORT = 'NYBB';
export const COMPANY_LONG_SHORT = 'Nelsonville York Band Boosters';
export const COMPANY_ADDRESS_FULL = 'PO BOX 315, NELSONVILLE, OH 45764-0315';
export const COMPANY_LOCATION = 'Nelsonville, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=PO%20BOX%20315%2C%20NELSONVILLE%2C%20OH%2045764-0315';

export const PROFILE_FACTS = [
  { label: 'Role', value: 'Booster support for school band program' },
  { label: 'Community', value: 'Nelsonville-York City Schools' },
  { label: 'Location', value: COMPANY_LOCATION },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Mailing Address', value: COMPANY_ADDRESS_FULL },
];

export const PROGRAM_FOCUS = [
  {
    tag: 'BAND',
    title: 'Band Program Support',
    body: 'NYBB is presented publicly as a booster organization supporting the Nelsonville-York school band community.',
  },
  {
    tag: 'PARENTS',
    title: 'Parent & Volunteer Network',
    body: 'The layout reflects the parent-and-volunteer culture typical of small-town Ohio band booster groups.',
  },
  {
    tag: 'PROFILE',
    title: 'Conservative Public Profile',
    body: 'The page keeps the supplied mailing address visible while private registry and tax identifiers remain off the client page.',
  },
  {
    tag: 'COMMUNITY',
    title: 'Community Presence',
    body: 'Nelsonville sits in Athens County, Ohio — this page references the public mailing address tied to that community.',
  },
];

export const QUICK_NUMBERS = [
  { label: 'Town', value: 'Nelsonville' },
  { label: 'County', value: 'Athens, OH' },
  { label: 'ZIP', value: '45764' },
];
